import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, description, testid }) => (
  <div className="mb-14" data-testid={testid}>
    <Reveal>
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-blue-500 font-semibold mb-4 flex items-center gap-3">
        <span className="inline-block w-8 h-px bg-blue-500" />
        {overline}
      </p>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold uppercase tracking-tight text-gray-100 max-w-3xl">
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.2}>
        <p className="mt-4 text-base sm:text-lg text-gray-400 max-w-2xl leading-relaxed">{description}</p>
      </Reveal>
    )}
  </div>
);
